// TODO: Maybe use env variable
export const GA_DISABLED = false;
export const GA_SHOW_CONSENT_BANNER = false;

export const CONSENT_STATUS_ENUM = {
  'NOT_SET': 'not_set',
  'ACCEPTED': 'accepted',
  'REJECTED': 'rejected',
} as const;

export type ConsentStatus = typeof CONSENT_STATUS_ENUM[keyof typeof CONSENT_STATUS_ENUM];

export const GA_EVENT_NAME_ENUM = {
  'OPEN_CHATBOT': 'open_chatbot',
  'MINIMIZE_CHATBOT': 'minimize_chatbot',
  'CLOSE_CHATBOT': 'close_chatbot',

  'CONTACT_SUPPORT_REQUEST': 'contact_support_request',

  'START_OPEN_REQUEST_CREATION': 'start_open_request_creation',
  'START_LIVE_CHAT_CONNECTION': 'start_live_chat_connection',
  'START_VOICE_CHAT_CONNECTION': 'start_voice_chat_connection',

  'OPEN_REQUEST_CREATED': 'open_request_created',
  'LIVE_CHAT_CONNECTED': 'live_chat_connected',

  'OPEN_REQUEST_CREATION_FAILED': 'open_request_creation_failed',
  'LIVE_CHAT_CONNECTION_FAILED': 'live_chat_connection_failed',

  'START_NEW_CONVERSATION': 'start_new_conversation',
  'MY_REQUESTS_INIT': 'my_requests_init',

  'SELECT_CATEGORY': 'select_category',
  'SELECT_SECTION': 'select_section',

  // Open/contact/action conversation
  'OPEN_ARTICLE': 'open_article',
  'ARTICLE_CONTACT_SUPPORT': 'article_contact_support',
  'ARTICLE_ACTION_USAGE': 'used_article_action',
  'ARTICLE_GO_BACK': 'article_go_back',

  'ARTICLE_HELPFUL': 'article_helpful',
  'ARTICLE_NOT_HELPFUL': 'article_not_helpful',

  // Shown warning / cancel request warning
  'TRANSACTION_WARNING_SHOWN': 'transaction_warning_shown', // Should go with transaction warning name custom dimension
  'CANCEL_REQUEST_TRANSACTION_WARNING': 'cancel_request_transaction_warning',

  // Remedy transaction flow and conversion
  'REMEDY_TRANSACTION_SHOWN': 'remedy_transaction_shown',
  'REMEDY_TRANSACTION_RUN': 'remedy_transaction_run',
  'REMEDY_TRANSACTION_RUN_MATCH_FAILED': 'remedy_transaction_run_match_failed',
  'REMEDY_TRANSACTION_RUN_FAILED': 'remedy_transaction_run_failed',
  'REMEDY_TRANSACTION_RUN_FINISHED': 'remedy_transaction_run_finished',
  'REMEDY_TRANSACTION_NEW_STATUS_': 'remedy_transaction_new_status_', // New status should be appended
  'CONTACT_SUPPORT_AFTER_REMEDY': 'contact_support_after_remedy',
  'GO_TO_TRANSACTIONS_AFTER_REMEDY': 'go_to_transactions_after_remedy',

  'METADATA_TRANSACTION_NEW_STATUS_': 'metadata_transaction_new_status_', // New status should be appended

  'CHAT_RATING_SHOW': 'chat_rating_show',
  'CHAT_RATING_SUBMIT': 'chat_rating_submit',
  'CHAT_RATING_SKIP': 'chat_rating_skip',

  'RESUMABLE_CHAT_SHOW': 'resumable_chat_show',
  'RESUMABLE_CHAT_CONTINUE': 'resumable_chat_continue',
  'RESUMABLE_CHAT_CANCEL': 'resumable_chat_cancel',
  'RESUMABLE_CHAT_GO_TO_ACTIVE_CONVERSATION': 'resumable_chat_go_to_active_conversation',
  'RESUMABLE_CHAT_GO_TO_MY_REQUESTS': 'resumable_chat_go_to_my_requests',
  'RESUMABLE_CHAT_GO_TO_NEW_CHAT': 'resumable_chat_go_to_new_chat',

  'VOICE_CHAT_REGISTER': 'voice_chat_register',
  'VOICE_CHAT_REGISTERING': 'voice_chat_registering',
  'VOICE_CHAT_REGISTERED': 'voice_chat_registered',
  'VOICE_CHAT_UNREGISTERED': 'voice_chat_unregistered',
  'VOICE_CHAT_CALL_ACCEPTED': 'voice_chat_call_accepted',
  'VOICE_CHAT_CALL_RECONNECTING': 'voice_chat_call_reconnecting',
  'VOICE_CHAT_CALL_RECONNECTED': 'voice_chat_call_reconnected',
  'VOICE_CHAT_CALL_ERROR': 'voice_chat_call_error',
  'VOICE_CHAT_CALL_CANCEL': 'voice_chat_call_cancel',
  'VOICE_CHAT_CALL_DISCONNECTED': 'voice_chat_call_disconnected',
  'VOICE_CHAT_ERROR': 'voice_chat_error',
  'VOICE_CHAT_CONNECTED_SUCCESSFUL': 'voice_chat_connected_successful',
  'VOICE_CHAT_CONNECTED_FAILED': 'voice_chat_connected_failed',
  'VOICE_CHAT_CALL_SAMPLE': 'voice_chat_call_sample',

} as const;

export const GA_EVENT_CUSTOM_DIMENSION_ENUM = {
  'ARTICLE_OPEN_SOURCE': 'article_open_source',
  'ARTICLE_ACTION_AVAILABLE': 'article_action_available',
  'ARTICLE_ACTION_TYPE': 'article_action_type',
  'CONTACT_SUPPORT_AVAILABLE': 'contact_support_available',
  'CONTACT_SUPPORT_TYPE': 'contact_support_type',
  'TRANSACTION_WARNING_TYPE': 'transaction_warning_type',
  'REMEDY_TRANSACTION_UPDATED_SUCCESSFULLY': 'remedy_transaction_updated_successfully',
  'RESUMABLE_CHAT_TYPE': 'resumable_chat_type',
  'CATEGORY_NAME': 'category_name',
  'SECTION_NAME': 'section_name',
  'ERROR_MESSAGE': 'error_message',
  'ERROR_CODE': 'error_code',
  'REMEDY_DATA': 'remedy_data',
  'TRADE_ID': 'trade_id',
} as const;
